/**
 * Part of the SuggestionAction in charge of matching a text.
 * It's both matching the editor text with the triggerCharacter
 * or matching a suggestion again the input text.
 *
 * @param {string} [triggerCharacter] - Character for triggering the suggestions list
 * @param {function(object):boolean} [isSuggestionMatching] - Callback to define the conditions that will apply
 *   to create the suggestions list
 * @param {function(object):string} [suggestionToLabel] - Callback that returns the value to label the items
 */
export default class SuggestionMatcher {
	constructor({
		triggerCharacter = "#",
		isSuggestionMatching = (...args) =>
			this._defaultIsSuggestionMatching(...args),
		suggestionToLabel = (suggestion) => suggestion.toString(),
	}) {
		this._isSuggestionMatching = isSuggestionMatching;
		this._suggestionToLabel = suggestionToLabel;

		this._triggerRegexp = new RegExp(
			`(^|\\s)${triggerCharacter}([-0-9A-zÀ-ÿ]+)$`,
		);
	}

	isSuggestionMatching({ suggestion, text }) {
		return this._isSuggestionMatching({ suggestion, text });
	}

	getTriggerMatch($position) {
		const before = $position.before();
		const text = $position.doc.textBetween(
			before,
			$position.pos,
			"\n",
			"\0",
		);

		const match = text.match(this._triggerRegexp);

		if (match) {
			const length = match[0].startsWith(" ")
				? match[0].length - 1
				: match[0].length;

			let offset = 0;

			$position.doc.nodesBetween(before, $position.pos, (node) => {
				if (!node.type.name.startsWith("inputValue_")) {
					return true;
				}
				offset += 2;
				return false;
			});

			const to = $position.start() + match.input.length + offset;
			const from = to - length;

			const queryText = match[2];

			return {
				range: { from, to },
				queryText,
			};
		}

		return "";
	}

	_defaultIsSuggestionMatching({ text, suggestion }) {
		return this._suggestionToLabel(suggestion)
			.toLowerCase()
			.includes(text.toLowerCase());
	}
}
